export default {
  methods: {
    copyToClipboard(text){
      let element = document.createElement("input");
      document.body.appendChild(element);
      element.setAttribute('value', text);
      element.select();
      document.execCommand("copy");
      document.body.removeChild(element);
    }
  }
}
